// Gallery immagini nella product card (PLP).
// Le slide extra arrivano senza src: si scaricano solo quando l'utente scorre (swipe, trackpad o frecce),
// la slide visibile + la successiva. Nessun byte in più al caricamento della pagina.
// Si re-inizializza da sola quando ProductCard.renderCard() sostituisce [data-image] (cambio colore swatch).
if (!customElements.get('card-gallery')) {
  class CardGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      // Spenta nei caroselli Swiper (swipe annidato) e se c'è una sola immagine
      if (this.slides.length < 2 || this.closest('.swiper-slide')) return;

      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;

      this.onScroll = () => {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.load(i);
        this.load(i + 1);
        if (this.track.scrollLeft > 0) this.setAttribute('data-nav', '');
        if (i !== this.index) {
          this.index = i;
          this.updateArrows();
        }
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.prev?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));
      // Prefetch della prossima slide quando il mouse si avvicina alla freccia
      this.next?.addEventListener('pointerenter', () => this.load(this.index + 1));

      // Desktop: in hover la card mostra già la 2a immagine, quindi per le frecce siamo sulla slide 2
      // ("<" torna alla 1a, ">" va alla 3a: niente immagine ripetuta)
      const hoverMq = window.matchMedia('(min-width: 990px) and (hover: hover)');
      const hasHoverImg = !!this.slides[0].querySelector('picture');
      this.onEnter = (e) => {
        if (e.pointerType !== 'mouse' || !hasHoverImg || !hoverMq.matches || this.hasAttribute('data-nav')) return;
        this.index = 1;
        this.updateArrows();
      };
      // Uscendo dalla card si torna alla prima immagine e all'hover classico
      this.onLeave = (e) => {
        if (e.pointerType !== 'mouse') return;
        if (this.hasAttribute('data-nav')) {
          this.track.scrollTo({ left: 0, behavior: 'instant' });
          this.removeAttribute('data-nav');
        }
        this.index = 0;
        this.updateArrows();
      };
      this.wrapper = this.closest('[data-image]');
      this.wrapper?.addEventListener('pointerenter', this.onEnter);
      this.wrapper?.addEventListener('pointerleave', this.onLeave);
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.wrapper?.removeEventListener('pointerenter', this.onEnter);
      this.wrapper?.removeEventListener('pointerleave', this.onLeave);
    }

    load(i) {
      const img = this.slides[i]?.querySelector('img[data-src]');
      if (!img) return;
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    }

    go(i) {
      if (i < 0 || i >= this.slides.length) return;
      this.load(i);
      this.load(i + 1);
      // Primo click da hover: salto istantaneo (con lo smooth si vedrebbero scorrere le slide intermedie)
      const first = !this.hasAttribute('data-nav');
      this.setAttribute('data-nav', '');
      this.index = i;
      this.updateArrows();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: first || reduce ? 'instant' : 'smooth' });
    }

    updateArrows() {
      if (this.prev) this.prev.disabled = this.index <= 0;
      if (this.next) this.next.disabled = this.index >= this.slides.length - 1;
    }
  }
  customElements.define('card-gallery', CardGallery);
}
